
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"15.892"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M0 4.262c1.4.851 2.8 1.7 4.2 2.552q3 1.829 6.006 3.67a1.376 1.376 0 001.568 0q4.981-3.048 9.968-6.076c.07-.044.146-.089.26-.152v8.26a3.249 3.249 0 01-3.39 3.371H4.546a12.1 12.1 0 01-1.86-.07 3.166 3.166 0 01-2.629-2.673.425.425 0 00-.044-.114Q-.006 8.64 0 4.262z"}}),_c('path',{staticClass:"a",attrs:{"d":"M11.004.002h7.625a3.182 3.182 0 012.946 1.7c.108.19.165.406.26.61.076.171.025.26-.133.356q-4.629 2.819-9.244 5.644c-.425.26-.857.521-1.283.787a.248.248 0 01-.3.006L.285 2.654a.223.223 0 01-.114-.311A3.237 3.237 0 013.371 0c2.534-.004 5.086.002 7.633.002z"}})])
          )
        }
      }
    